var render = function render(){var _vm=this,_c=_vm._self._c;return _c('NewTask',{attrs:{"taskType":"financial_document","docList":['Financial Document']}})
}
var staticRenderFns = []

export { render, staticRenderFns }